module.exports = __webpack_public_path__ + "static/img/datapart.1d373e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/datapart.png
// module id = mFSK
// module chunks = 9